import React from 'react';
import {
    Material,
    Door,
    MaterialEdge,
    MaterialType,
} from 'components/customer/Materials/entity';
import {connect} from 'react-redux';
import {materialDetailsMapping} from 'components/customer/Materials/store/selectors/materialDetailsSelector';
import {Col, Row} from 'react-bootstrap';
import {parseHtmlString} from 'shared/helpers/HTMLParser';

export interface MaterialDetailsInterface {
    material?: Material;
    edge?: MaterialEdge;
    door?: Door;
    index?: number;
    materialType: MaterialType;
    hasDoor?: boolean;
    hasEdge?: boolean;
    noGap?: boolean;
}

const MaterialDetails = ({
    material,
    edge,
    door,
    materialType,
    hasDoor,
    hasEdge = true,
    noGap = false,
}: MaterialDetailsInterface) => {
    return (
        <Row style={{marginTop: noGap ? '0' : '15px'}}>
            <Col className="align-self-center">
                <>
                    <div style={{fontSize: '.9em'}}>
                        <strong className="primary-colour">Type : </strong>
                        {(material && material.type.name) || ''}
                    </div>

                    {materialType == MaterialType.EXTERIOR && hasDoor ? (
                        <div style={{fontSize: '.9em'}}>
                            <strong className="primary-colour">Door : </strong>
                            {(door && door.name) || ''}
                        </div>
                    ) : null}
                    <div style={{fontSize: '.9em'}}>
                        <strong className="primary-colour">Material : </strong>
                        {(material && parseHtmlString(material.displayName)) ||
                            ''}
                    </div>

                    {hasEdge ? (
                        <div style={{fontSize: '.9em'}}>
                            <strong className="primary-colour">
                                Edge Material :{' '}
                            </strong>
                            {edge ? parseHtmlString(edge.displayName) : ''}
                        </div>
                    ) : null}
                </>
            </Col>
        </Row>
    );
};

export default connect(materialDetailsMapping)(MaterialDetails);
